import { pushToDataLayer } from '@domain-group/fe-helper';

import * as ga from '../../../constants/ga';

const emailButtonClick = (): void => {
  pushToDataLayer({
    event: ga.event,
    eventAction: 'Email Button Click',
    eventCategory: ga.category.INTERACTION,
    eventLabel: 'Agency Profile',
  });
};

export default emailButtonClick;
